import React, { Component } from 'react';
import { connect } from 'react-redux';

import { saveDisplayAnnotationColorChange } from 'PipeRouter';
import CSS from './styles.css';
import {  CaretDown as CDIcon } from 'Shared/Icons';


const Fragment = React.Fragment;
const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

//what to display?
class FilterByMenu extends Component {
  constructor(props) {
    super(props);
  }

  onDisplayAnnotationColorChange = event => {
    const { displayAnnotationColors, saveDisplayAnnotationColorChange } = this.props;
    let updateDisplayColors = [];
    const { id, checked } = event.target || event;

    for (const color of displayAnnotationColors) {
      if (color.markerId === id) {
        color.display = checked;
      }

      updateDisplayColors.push(color);
    }

    saveDisplayAnnotationColorChange(updateDisplayColors);
  };

  openMenu = event => {
    let isExpanded = event.currentTarget.getAttribute('aria-expanded');

    if (event.target.textContent === 'Highlight Color' || event.target.tagName === 'polygon') {
      isExpanded = isExpanded === 'false'
        ? false
        : true;

      event.currentTarget.setAttribute('aria-expanded', !isExpanded);
      event.preventDefault();
      event.stopPropagation();
    }
  };

  renderMenu = () => {
    const { displayAnnotationColors } = this.props;

    return (
      <div className={ CSS['menu-container'] }>
        <ul className={ CSS['submenu'] }>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ onMenuItemKeyDown }>red</li>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ onMenuItemKeyDown }>green</li>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ onMenuItemKeyDown }>blue</li>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ onMenuItemKeyDown }>yellow</li>
          {
            displayAnnotationColors.map(el => {
              const { color, display, disabled, label, markerId } = el;
              return (
                <li key={ markerId } className={ CSS['list-item'] }>
                  <label className={ CSS['label-old'] } htmlFor={ markerId }></label>
                  <input type="checkbox" id={ markerId } checked={ display } disabled={ disabled } onChange={ this.onDisplayAnnotationColorChange }/>
                  <svg className={ CSS['svg-circle'] } width="20" height="20" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" fill={ color } />
                  </svg>
                  <span className={ CSS['label-text-old'] }>{ label }</span>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  };

  onMenuItemKeyDown = event => {
    const { currentParentIndex, goToNextMenuFromSubmenu } = this.props;
    const { keyCode, target } = event;
    const { nextElementSibling, previousElementSibling, parentNode } = target;
    const menuItems = parentNode.children;
    const firstMenuItem = menuItems[0];
    const miLen = menuItems.length;
    const lastMenuItem = menuItems[miLen - 1];

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        const parent = target.parentElement.parentElement;
        parent.setAttribute('aria-expanded', false);
        goToNextMenuFromSubmenu(parent, currentParentIndex - 1);
        event.preventDefault();
        event.stopPropagation();
      } else {
        const parent = target.parentElement.parentElement;
        parent.setAttribute('aria-expanded', false);
        goToNextMenuFromSubmenu(parent, currentParentIndex + 1);
        event.preventDefault();
        event.stopPropagation();
      }
    }

    if (keyCode === keys.esc) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      parent.focus();
    }

    if (keyCode === keys.down) {
      if (nextElementSibling) {
        nextElementSibling.focus();
        event.preventDefault();
        event.stopPropagation();
      } else {
        firstMenuItem.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }

    if (keyCode === keys.up) {
      if (previousElementSibling) {
        previousElementSibling.focus();
        event.preventDefault();
        event.stopPropagation()
        return false;
      } else {
        lastMenuItem.focus();
        event.preventDefault();
        event.stopPropagation()
        return false;
      }
    }

    if (keyCode === keys.right) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex + 1);
      event.preventDefault();
      event.stopPropagation();
    }
    if (keyCode === keys.left) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex - 1);
      event.preventDefault();
      event.stopPropagation();
    }

    if (keyCode === keys.enter || keyCode === keys.space) {
      const input = event.target.querySelector('input')
      input.checked = !input.checked;
      this.onDisplayAnnotationColorChange(input);
      event.preventDefault();
      event.stopPropagation();
    }
  };

  onMenuKeyDown = event => {
    const { currentParentIndex, goToNextMenu, goToNextMenuFromSubmenu, updateParentIndex } = this.props;
    const { keyCode, target } = event;
    const menus = target.parentElement.getElementsByClassName('menu');
    const mLen = menus.length;

    if (keyCode === keys.up) {
      const menu = target.querySelector('ul');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        target.setAttribute('aria-expanded', true);
        listItems[listItems.length-1].focus();
      }
    }

    if (keyCode === keys.down || keyCode === keys.space || keyCode === keys.enter) {
      const menu = target.querySelector('ul');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        target.setAttribute('aria-expanded', true);
        listItems[0].focus();
      }
    }

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        if (currentParentIndex - 1 < 0) {
          updateParentIndex(0);
        } else {
          goToNextMenu(target, currentParentIndex - 1);
          event.preventDefault();
        }
      } else {
        if (currentParentIndex === mLen-1) {
          updateParentIndex(mLen-1);
        } else {
          goToNextMenu(target, currentParentIndex + 1);
          event.preventDefault();
        }
      }
    }

    if (keyCode === keys.right) {
      if (currentParentIndex === mLen-1) {
        goToNextMenu(target, 0);
        event.preventDefault();
      } else {
        goToNextMenu(target, currentParentIndex + 1);
        event.preventDefault();
      }
    }

    if (keyCode === keys.left) {
      if (currentParentIndex === 0) {
        goToNextMenu(target, mLen - 1);
        event.preventDefault();
      } else {
        goToNextMenu(target, currentParentIndex - 1);
        event.preventDefault();
      }
    }
  };

  render() {
    const { displayAnnotationColors } = this.props;

    return (
      <Fragment>
        <span className={ CSS['filter_title'] }>Filter by:</span>
        <li id="filterBy" className={`menu ${CSS['menu']}`} role="menuitem" aria-haspopup="true" aria-expanded="false" onKeyDown={ this.onMenuKeyDown } onClick={ this.openMenu } tabIndex="0">
          <span className={ CSS['filter_subTitle'] }>Highlight Color</span>
          <CDIcon width="8px" height="6px" viewBox="0 0 8 6" fill="#00758e" />
          <ul role="menu" className={ CSS['submenu'] }>
            {
              displayAnnotationColors.map(el => {
                const { color, display, disabled, label, markerId } = el;

                return (
                  <li key={ markerId } className={ CSS['list-item'] } role="menuitem" tabIndex="-1" onKeyDown={ this.onMenuItemKeyDown }>
                    <label className={ CSS['filter_checkBox'] } htmlFor={ markerId }></label>
                    <input type="checkbox" id={ markerId } checked={ display } disabled={ disabled } onKeyDown={ this.onMenuItemKeyDown } onChange={ this.onDisplayAnnotationColorChange }/>
                    <svg className={ CSS['svg_circle'] } width="20" height="20" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" fill={ color } />
                    </svg>
                    <span className={ CSS['filter_label'] }>{ label }</span>
                  </li>
                );
              })
            }
          </ul>
        </li>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { notebook:{ displayAnnotationColors }} = state;
  return { displayAnnotationColors };
}


export default connect(mapStateToProps, {
  saveDisplayAnnotationColorChange
})(FilterByMenu);
